module.exports = __webpack_public_path__ + "img/banner-logo-bg.e076d14.jpg";